import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  counterStatus: 'closed'
};

const CounterSlice = createSlice({
  name: 'counter',
  initialState,
  reducers: {
    setCounterStatus: (state, action) => {
      state.counterStatus = action.payload;
    }
  }
});

export const { setCounterStatus } = CounterSlice.actions;
export default CounterSlice.reducer;
